import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaArrowUp } from "react-icons/fa";

const ScrollUp = ({ position }) => {
  const [visible, setVisible] = useState(true);

  const onScroll = () => {
    setVisible(document.documentElement.scrollTop === 0);
  };

  useEffect(() => {
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      {!visible && (
        <Button
          className="btn-success"
          id="scroll"
          onClick={() => (document.documentElement.scrollTop = 0)}
          style={{
            width: "50px",
            height: "50px",
            [position]: "25px", // Dynamically set left or right based on position prop
            position: "fixed",
            bottom: "90px",
            borderRadius: "50px",
            textAlign: "center",
            fontSize: "25px",
            boxShadow: "2px 2px 3px #999",
            zIndex: "100",
          }}
        >
          <FaArrowUp />
        </Button>
      )}
    </>
  );
};

export default ScrollUp;
